import Vue from 'vue'
import { Button, Icon, Tabbar, TabbarItem, NavBar, Toast, Swipe, SwipeItem, Empty, CellGroup, Cell, Divider, Field, Calendar, Popup, Picker, Dialog, Card, Progress, Tag, NoticeBar } from 'vant'

Vue.use(Button)
Vue.use(Icon)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Toast)
Vue.use(Empty)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Divider)
Vue.use(Field)
Vue.use(Calendar)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Progress)
Vue.use(Tag)
Vue.use(NoticeBar)
